import { computed, inject } from 'vue';
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers } from "vue";
import { useStore } from 'vuex';
export default {
  __name: 'LeftMenuItem',
  props: {
    menuInfo: Object,
    collapsed: Boolean
  },
  setup(__props) {
    const props = __props;
    const store = useStore();
    const menus = computed(() => store.state.menus);
    const menuClick = inject('menuClick');
    return (_ctx, _cache) => {
      var _props$menuInfo, _props$menuInfo$child;
      const _component_d_icon = _resolveComponent("d-icon");
      const _component_LeftMenuItem = _resolveComponent("LeftMenuItem", true);
      const _component_a_sub_menu = _resolveComponent("a-sub-menu");
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      return ((_props$menuInfo = __props.menuInfo) === null || _props$menuInfo === void 0 ? void 0 : (_props$menuInfo$child = _props$menuInfo.children) === null || _props$menuInfo$child === void 0 ? void 0 : _props$menuInfo$child.length) > 0 ? (_openBlock(), _createBlock(_component_a_sub_menu, {
        key: __props.menuInfo.id
      }, {
        icon: _withCtx(() => {
          var _props$menuInfo2, _props$menuInfo2$meta;
          return [_createVNode(_component_d_icon, {
            type: (_props$menuInfo2 = __props.menuInfo) === null || _props$menuInfo2 === void 0 ? void 0 : (_props$menuInfo2$meta = _props$menuInfo2.meta) === null || _props$menuInfo2$meta === void 0 ? void 0 : _props$menuInfo2$meta.icon,
            style: {
              fontSize: '14px'
            },
            class: _normalizeClass({
              'collapsed': __props.collapsed
            })
          }, null, 8, ["type", "class"])];
        }),
        title: _withCtx(() => [_createTextVNode(_toDisplayString(__props.menuInfo.meta.title), 1)]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuInfo.children, item => {
          return _openBlock(), _createBlock(_component_LeftMenuItem, {
            key: item.id,
            menuInfo: item,
            collapsed: __props.collapsed
          }, null, 8, ["menuInfo", "collapsed"]);
        }), 128))]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_a_menu_item, {
        key: __props.menuInfo.id,
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => _unref(menuClick)(__props.menuInfo), ["prevent"]))
      }, {
        icon: _withCtx(() => {
          var _props$menuInfo3, _props$menuInfo3$meta;
          return [_createVNode(_component_d_icon, {
            type: (_props$menuInfo3 = __props.menuInfo) === null || _props$menuInfo3 === void 0 ? void 0 : (_props$menuInfo3$meta = _props$menuInfo3.meta) === null || _props$menuInfo3$meta === void 0 ? void 0 : _props$menuInfo3$meta.icon,
            style: {
              fontSize: '14px'
            },
            class: _normalizeClass({
              'collapsed': __props.collapsed
            })
          }, null, 8, ["type", "class"])];
        }),
        default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(__props.menuInfo.meta.title), 1)]),
        _: 1
      }));
    };
  }
};